module.exports = __webpack_public_path__ + "img/home_bg_right.01442c88.png";